import { flow } from 'fp-ts/function';
import { constant, filter, get, includes, map } from 'lodash/fp';
import { useMemo } from 'react';
import { Option } from '@mews-commander/legacy-data-structures';
import { localizeEnumify, notNil, sortByAscending } from '@mews-commander/utils';
import { when } from '@mews/fp';
import { FieldProps } from '@optimus-web/core';
import { useHintText } from '@mews-commander/form';
import { EnumValue } from '@mews/enumify';
import { SelectField } from './SelectField';

interface Props extends FieldProps {
    disabledValues?: $TSFixMe[];
    enumClass: $TSFixMe;
    enabledValues?: $TSFixMe[];
    useNameAsValue?: boolean;
    multiselect?: boolean;
    showEmptyValue?: boolean;
}

/**
 * @deprecated use EnumSelectField with generated enums
 */
export const EnumifySelectField = ({ enabledValues, enumClass, useNameAsValue, ...fieldProps }: Props) => {
    const createHintText = useHintText();

    const options = useMemo(() => {
        const getOptionsFromEnumClass = flow(
            get('enumValues'),
            when(
                constant(notNil(enabledValues)),
                // @ts-expect-error $TSFixMeError: Argument of type 'LodashFilter2x1<unknown>' is not assignable to parameter of type 'Func<[], unknown[]>'.
                filter((enumValue) => includes(enumValue, enabledValues))
            ),
            map((e: $TSFixMe) => {
                const enumValue = e as EnumValue;
                return Option({
                    disabled: includes(enumValue, fieldProps.disabledValues),
                    label: localizeEnumify(enumValue),
                    secondaryText: createHintText('', enumValue.toString(), ''),
                    value: useNameAsValue ? enumValue.name : enumValue.value,
                });
            }),
            sortByAscending('label')
        );

        return getOptionsFromEnumClass(enumClass);
    }, [createHintText, enabledValues, enumClass, fieldProps.disabledValues, useNameAsValue]);

    return <SelectField {...fieldProps} options={options} />;
};
